var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileFalse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3600 3600",
    style: {
      enableBackground: "new 0 0 3600 3600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E5E5E5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1800,3600C805.5,3600,0,2794.5,0,1800S805.5,0,1800,0s1800,805.5,1800,1800S2794.5,3600,1800,3600z M1800,3420 c531,0,1003.5-256.5,1300.5-652.5c-297-396-769.5-652.5-1300.5-652.5S796.5,2371.5,499.5,2767.5C796.5,3163.5,1269,3420,1800,3420 L1800,3420z M1800,180C904.5,180,180,904.5,180,1800c0,292.5,81,571.5,216,810c328.5-409.5,837-675,1404-675s1075.5,261,1404,675 c139.5-238.5,216-513,216-810C3420,904.5,2695.5,180,1800,180z M1800,1755c-346.5,0-630-283.5-630-630s283.5-630,630-630 s630,283.5,630,630S2146.5,1755,1800,1755z M1800,675c-247.5,0-450,202.5-450,450s202.5,450,450,450s450-202.5,450-450 S2047.5,675,1800,675z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFalse);
export default __webpack_public_path__ + "static/media/profile-false.cf2d9c8974d00626d1c5d24a56e5a3ba.svg";
export { ForwardRef as ReactComponent };